import React from "react";
import SchedaProdottoPSlingua from "./SchedaProdottoPSlingua";

function SchedaProdottoPS({prod}) {
    
    if (prod !== "no data") {
        
        return (
            <div className="schedaProdPS">
                <p>
                {prod?.codiceVS && <span><strong>COD VS: </strong>{prod.codiceVS}</span>}
                {prod?.codicePS && <span><strong>  COD PS: </strong>{prod.codicePS}</span>}
                {prod?.codiceProduttore?.codProduttoreIntero && <span><strong>  COD PROD: </strong>{prod.codiceProduttore?.codProduttoreIntero}</span>}
                {prod?.brand && <span><strong>  BRAND: </strong>{prod.brand}</span>}
                </p>
                <p><strong>QUANTITA': </strong>{prod.quanti}</p>
                <div className="lingueProdPS flex">
                <SchedaProdottoPSlingua prod={prod} lang="it" />
                <SchedaProdottoPSlingua prod={prod} lang="en" />
                <SchedaProdottoPSlingua prod={prod} lang="fr" />
            </div>

            </div>
            
        );
    } else {
        return (
            <p>Nessun prodotto selezionato</p>
        );
    }

}

export default SchedaProdottoPS;